//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "./../layouts/Header.vue";

import Footer from "./../layouts/Footer.vue";
import emailjs from "emailjs-com";

export default {
  name: "contact",
  data() {
    return {
      contactForm: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        company: "",
        message: "",
      },

      isSubmitted: false
    };
  },
  components: {
    Header,
  
    Footer,
  },
  methods: {
    sendEmail() {
      emailjs
        .send(
          "service_mmdutcs",
          "template_7o8siur",
          this.contactForm,
          "user_bbZeudqF6d1pcyacAYiHO"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );

      // Reset form field
      this.contactForm.firstName = "";
      this.contactForm.lastName = "";
      this.contactForm.phone = "";
      this.contactForm.company = "";
      this.contactForm.email = "";
      this.contactForm.message = "";

      this.isSubmitted = true;
    },
  },
  head: {
    title: 'Contact Us | Mazecare',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Connect with Mazecare'
      },
      {
        name: "keywords",
        content: "contact mazecare"
      }
    ],
  }
};
